import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Register Service Worker for PWA functionality
const registerServiceWorker = async () => {
  if ('serviceWorker' in navigator) {
    try {
      const registration = await navigator.serviceWorker.register('/sw.js', {
        scope: '/',
      });
      
      if (registration.installing) {
        console.log('[PWA] Service worker installing');
      } else if (registration.waiting) {
        console.log('[PWA] Service worker installed, waiting');
      } else if (registration.active) {
        console.log('[PWA] Service worker active');
      }
      
      // Handle updates
      registration.addEventListener('updatefound', () => {
        const newWorker = registration.installing;
        if (newWorker) {
          newWorker.addEventListener('statechange', () => {
            if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
              // New content available, show update prompt if needed
              console.log('[PWA] New content available, refresh to update');
            }
          });
        }
      });
      
    } catch (error) {
      console.error('[PWA] Service worker registration failed:', error);
    }
  }
};

// Register SW after page loads
window.addEventListener('load', registerServiceWorker);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
